import { __read, __spread } from "tslib";
/**
 * Позволяет безопасно вызывать пользовательские и внутренние функции компонента.
 *
 * @example
 * forkFn(props.onClick, internalOnClick)
 */
export var forkFn = function (originFn, forkedFn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (originFn !== undefined) {
            originFn.apply(void 0, __spread(args));
        }
        forkedFn.apply(void 0, __spread(args));
    };
};
